// extracted by mini-css-extract-plugin
module.exports = {"mainFrame":"frame_mainFrame__n5E2u","framImg":"frame_framImg__iQxNv","tabText":"frame_tabText__EIpJv","active":"frame_active__NYwYD","tabs":"frame_tabs___fTqH"};